import React, {useState, useEffect, useRef} from "react";
import {useParams, useLocation, useHistory} from "react-router-dom";
import {SelectStyled} from "../../styles/Forms";
import {Grid, Col} from "../../styles/Grid";
import FormPartOne from "./components/FormPartOne";
import FormPartFour from "./components/FormPartFour";
import styled from "styled-components";
import {CreateCourseService} from "../../services/CoursesServices";
import AppLoader from "../../components/loaders/Loader";
import FormPartTwo from "./components/FormPartTwo";
import {AppButton} from "../../styles/Butttons";
import FormPartThree from "./components/FormPartThree";
import FormPartTestimonials from "../offerEdit/components/FormPartTestimonials";

export default function OfferAdd({theme}) {
   let location = useLocation();
   let history = useHistory();
   let secondF = useRef(null);
   let viewRef = useRef(null);
   const [dataCourse, setData] = useState({});
   // const [dataCourse, setData] = useState({idCourse: 43});
   let {type} = useParams();
   const [addTo, setAdd] = useState(null);
   const [showSuccess, setSuccess] = useState(false);
   const [isSaving, setSaving] = useState(false);
   const [currentPage, setCurrentPage] = useState(1);

   useEffect(() => {
      console.log(type);
      searchAdd();
   }, [type]);

   function searchAdd() {
      let newAdd = ConfigArray.find((item) => item.id === Number(type));
      // console.log();
      setAdd(newAdd);
   }

   const scrollToRef = (ref) => {
      viewRef.current.scrollTo({top: ref.current.offsetTop, behavior: "smooth"});
   };

   if (!addTo) return <p>Error en la selección: </p>;

   return (
      <>
         <View ref={viewRef}>
            <Grid>
               <Col large={10} offsetL={1}>
                  {/* {addTo} */}
                  <PartsContent>
                     <Parts className={currentPage === 1 ? "isActive" : ""}>
                        <FormPartOne
                           continueAction={() => setCurrentPage(2)}
                           sections={addTo.sections}
                           dataCourse={dataCourse}
                           setData={setData}
                        />
                     </Parts>

                     {addTo.sections.find((item) => item === 2) && (
                        <Parts ref={secondF} className={currentPage === 2 ? "isActive" : ""}>
                           <FormPartTwo
                              idCourse={dataCourse.idCourse}
                              continue={() => {
                                 setCurrentPage(3);
                              }}
                              sections={addTo.sections}
                           />
                        </Parts>
                     )}

                     {addTo.sections.find((item) => item === 3) && (
                        /* Temario */
                        <Parts ref={secondF} className={currentPage === 3 ? "isActive" : ""}>
                           <FormPartThree
                              idCourse={dataCourse.idCourse}
                              sections={addTo.sections}
                              continue={() => {
                                 setCurrentPage(4);
                              }}
                           />
                        </Parts>
                     )}

                     {addTo.sections.find((item) => item === 4) && (
                        /* Facilitadores */
                        <Parts ref={secondF} className={currentPage === 4 ? "isActive" : ""}>
                           <FormPartFour idCourse={dataCourse.idCourse} sections={addTo.sections} theme={theme} />
                        </Parts>
                     )}
                  </PartsContent>
               </Col>
            </Grid>
         </View>
         <AppLoader isVisible={isSaving} />
      </>
   );
}

const View = styled.div`
   background: white;
   width: 100%;
   height: 100%;
   overflow-y: scroll;
`;

const PartsContent = styled.div`
   position: relative;
   // background: plum;
   width: 100%;
   height: 100%;
`;

const Parts = styled.div`
   width: 100%;
   height: 100%;
   z-index: 0;
   opacity: 0;
   height: 0;
   overflow: hidden;

   &.isActive {
      z-index: 10000000;
      opacity: 1;
      height: auto;
      overflow: initial;
   }
`;

const ConfigArray = [
   {title: "Cursos esenciales", back: "#af0069", id: 1, sections: [1, 2, 3, 4, 5]},
   {title: "Certificado prime", back: "#8e44ad", id: 2, sections: [1, 2, 3, 4, 5]},
   {title: "Programa emblem", back: "#2980b9", id: 3, sections: [1]},
   {title: "Programa enterprise", back: "#95afc0", id: 4, sections: [1, 2, 3, 4, 5]},
   {title: "Certificado masterclass", back: "#8e44ad", id: 5, sections: [1, 2, 3, 4, 5]},
];
